/* Bellori — article : Sommaire auto (depuis les H2), scroll-highlight, Copier le lien. */
(function () {
  'use strict';
  var art = document.querySelector('[data-article]');
  if (!art) return;

  /* Copier le lien / partage */
  art.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = btn.getAttribute('data-copy');
      var done = function () { var t = btn.textContent; btn.textContent = 'Copié'; setTimeout(function () { btn.textContent = t; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(val).then(done, done);
      else { var ta = document.createElement('textarea'); ta.value = val; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); done(); }
    });
  });

  /* Sommaire depuis les H2 du corps */
  var body = art.querySelector('[data-article-body]');
  var toc = art.querySelector('[data-toc]');
  var tocList = art.querySelector('[data-toc-list]');
  if (!body || !toc || !tocList) return;
  var h2s = Array.prototype.slice.call(body.querySelectorAll('h2'));
  if (h2s.length < 2) return;

  var links = [];
  h2s.forEach(function (h, i) {
    if (!h.id) h.id = 'section-' + (i + 1);
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: h.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
      history.replaceState(null, '', '#' + h.id);
    });
    tocList.appendChild(a);
    links.push(a);
  });
  toc.hidden = false;

  /* Scroll-highlight de la section active */
  function onScroll() {
    var y = window.scrollY + 120, active = 0;
    h2s.forEach(function (h, i) { if (h.offsetTop <= y) active = i; });
    links.forEach(function (a, i) { a.classList.toggle('is-on', i === active); });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { onScroll(); ticking = false; });
  }, { passive: true });
  onScroll();
})();
